import { Button, DrawerBody, DrawerFooter, SubmitButton } from "@dgs/core";
import { Formik } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { TagMultiSelectField } from "../../../../shared/ui/TagSelectField";
import { TagIndexResource } from "../../shared/types";
import { CreateCompanyStepForm, DrawerForm, FormActions } from "./Form";

export interface TagsFormValues {
	tags: TagIndexResource[];
}

export const emptyTagsFormValues: TagsFormValues = { tags: [] };

interface Props extends CreateCompanyStepForm<TagsFormValues> {
	onGoBack: () => void;
}

export const TagsForm: FC<Props> = ({ onGoBack, initialValues, onSubmit }) => {
	const { t } = useTranslation();

	return (
		<Formik initialValues={initialValues} onSubmit={onSubmit}>
			<DrawerForm>
				<DrawerBody>
					<TagMultiSelectField label={t("Tags")} name="tags" />
				</DrawerBody>
				<DrawerFooter>
					<span />
					<FormActions>
						<Button type="button" onClick={onGoBack}>
							{t("Back")}
						</Button>
						<SubmitButton>{t("Save")}</SubmitButton>
					</FormActions>
				</DrawerFooter>
			</DrawerForm>
		</Formik>
	);
};
